<template>
  <div class="wrap">
    <Menu :menu="menu" />
    <v-toolbar flat color="white">
      <v-toolbar-title class="justify-space-between d-flex wrap">
        <span>Формы лендинга # {{ getCurrentLandingId() }}</span>
        <router-link :to="`/forms/add?landing_id=${getCurrentLandingId()}`">
          <v-btn color="primary">Добавить</v-btn>
        </router-link>
      </v-toolbar-title>
    </v-toolbar>
    <template v-if="items.length">
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="items" :search="search">
          <template v-slot:item.actions="{ item }">
            <router-link
              :to="
                `/forms/results?landing_id=${getCurrentLandingId()}&form_id=${
                  item.id
                }`
              "
            >
              <v-btn
                color="primary"
                title="Результаты форм"
                class="pl-0 pr-0 mr-3"
              >
                <v-icon left>
                  mdi-form-select
                </v-icon>
              </v-btn>
            </router-link>
            <router-link
              :to="
                `/forms/edit?landing_id=${getCurrentLandingId()}&form_id=${
                  item.id
                }`
              "
            >
              <v-btn color="primary" class="pl-0 pr-0 mr-3">
                <v-icon left>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </router-link>
            <v-btn
              color="red"
              class="pl-0 pr-0 white--text"
              @click="deleteForm(item)"
            >
              <v-icon left>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
              Reset
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </template>
    <template v-else>
      <v-card-text>
        Список пуст
      </v-card-text>
    </template>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :multi-line="multiLine" color="red">
      {{ errorText }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { API_URL_PREFIX, GLOBAL } from "@/config/consts";
import Menu from "@/components/Menu.vue";
import { mapGetters } from "vuex";

export default {
  name: "Forms",
  data() {
    return {
      items: [],
      search: "",
      headers: [
        { text: "ID формы", value: "id" },
        { text: "Название формы", value: "name" },
        { text: "Текст после успешной отправки", value: "success_text" },
        { text: "Текст кнопки отправки", value: "button_text" },
        { text: "Дата", value: "created_at" },
        { text: "Действия", value: "actions", sortable: false }
      ],
      multiLine: true,
      snackbar: false,
      errorText: "",
      overlay: false
    };
  },
  components: {
    Menu
  },
  computed: {
    ...mapGetters(["getErrorText"]),
    isBase() {
      return this.getCurrentLandingId() === this.baseLandingId;
    },
    baseLandingId() {
      return GLOBAL.baseLandingId;
    },
    menu() {
      return [
        { icon: "mdi-home", text: "На главную", link: "/" },
        {
          icon: "mdi-puzzle-plus",
          text: this.isBase ? "Базовые блоки" : "Конструктор блоков",
          link: `/blocks?landing_id=${this.getCurrentLandingId()}`
        },
        {
          icon: "mdi-text",
          text: this.isBase ? "Базовый менеджмент" : "Менеджмент",
          link: `/management?landing_id=${this.getCurrentLandingId()}`
        },
        {
          icon: "mdi-contacts",
          text: "Формы",
          link: `/forms?landing_id=${this.getCurrentLandingId()}`
        }
      ];
    }
  },
  async created() {
    await this.initialize();
  },
  methods: {
    getCurrentLandingId() {
      return this.$route.query.landing_id;
    },
    async initialize() {
      await this.getBlockList(this.getCurrentLandingId());
    },
    async getBlockList(id) {
      try {
        this.overlay = true;
        const { data } = await this.$axios.get(
          `${API_URL_PREFIX}/landings/${id}/forms/list`
        );
        this.items = data.list;
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      } finally {
        this.overlay = false;
      }
    },
    async deleteForm(item) {
      if (confirm("Вы уверены, что хотите удалить этот элемент?")) {
        try {
          const index = this.items.indexOf(item);
          await this.$axios.delete(
            `${API_URL_PREFIX}/landings/${this.getCurrentLandingId()}/forms/${
              item.id
            }`
          );
          this.$delete(this.items, index);
        } catch ({ response }) {
          this.snackbar = true;
          this.errorText = this.getErrorText(response);
        }
      }
    }
  }
};
</script>
